import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.885 10.115 9 13l2.885 2.884M6.115 6.27 9 3.384 6.115.5",
  stroke: "#8D8A84",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 13h5.77a2.564 2.564 0 0 0 2.563-2.564V5.949a2.564 2.564 0 0 0-2.564-2.564h-1.923M9 3.385H3.23A2.564 2.564 0 0 0 .666 5.949v4.487A2.564 2.564 0 0 0 3.23 13h1.923",
  stroke: "#8D8A84",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }